import React, { Suspense } from 'react'
import PageLoader from '../../component/Elements/pageLoader'
import { lazyWithRetry } from '../../helper/lazyWithRetry'

const StampsSettings = lazyWithRetry(() => import(/* webpackChunkName: "stamps" */'../../component/StampsSettings'))

const StampsSettingsPage = React.memo(() => {
	return (
		<Suspense fallback={<PageLoader />}>
			<StampsSettings />
		</Suspense>
	)
})

StampsSettingsPage.displayName = 'StampsSettingsPage'
export default StampsSettingsPage

